/* eslint-disable react/no-unescaped-entities */
import {
  Box,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import {
  RedLinkButton,
  getProductName,
  getTotalProductNum,
} from 'pages/ticketV2/common';
import React from 'react';
import { useTicketsStore } from 'pages/ticketV2/store/ticketsStore';
import { isDiscountTicket, Roles } from 'utils/constants';
import { SdmSelectV5 } from 'components/SdmSelectV5';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';

const ContainerHeader = ({
  currentTicket,
  onEdit,
  onRemove,
  locale,
  isChangingTicket,
  loggedUser,
  onChangeTicketType,
  assignTicketTexts,
}) => {
  const isOperator = loggedUser.type === Roles.OPERATOR;
  const isPrd = isOperator && currentTicket?.code?.includes('PRD_');
  const intl = useIntl();
  const i18nCommon = translations.TicketsV2(intl).Common;
  const i18nDiscount = translations.DiscountCode(intl);
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const {
    fetchedProducts,
    productsInCart,
    stepperCurrentTicketIdx,
    submittedDiscountCodesWithEmptySpaces,
  } = useTicketsStore();

  const ticketOptions = fetchedProducts.map((prod) => ({
    value: prod.id,
    label: getProductName(prod, locale),
  }));

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <Stack
        gap={'25px'}
        sx={{
          p: '30px',
          boxShadow: '0px 0px 5px 0px rgba(51, 51, 51, 0.05)',
          bgcolor: 'white',
        }}
      >
        {currentTicket ? (
          <>
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              <Stack direction={'row'} alignItems={'center'} gap={'10px'}>
                {isLgUp ? (
                  <div style={{ fontSize: '30px', paddingTop: '4px' }}>
                    <ConfirmationNumberOutlinedIcon fontSize="inherit" />
                  </div>
                ) : (
                  <ConfirmationNumberOutlinedIcon
                    fontSize="medium"
                    sx={{
                      mb: '4px',
                    }}
                  />
                )}
                <Typography
                  variant="m-bold"
                  fontFamily={'Suisse-Intl'}
                  component={'h2'}
                >
                  {assignTicketTexts.ticket} ({stepperCurrentTicketIdx + 1}/
                  {getTotalProductNum(productsInCart)})
                </Typography>
              </Stack>
              <Stack direction={'row'} alignItems={'center'} gap={'30px'}>
                {!isOperator ? (
                  <RedLinkButton
                    onClick={onEdit}
                    msg={i18nCommon.edit}
                    icon={<ModeEditOutlineOutlinedIcon color="primary" />}
                    hideTextOnMobile={true}
                  />
                ) : null}
                <RedLinkButton
                  onClick={onRemove}
                  msg={i18nCommon.delete}
                  icon={<DeleteOutlineOutlinedIcon color="primary" />}
                  hideTextOnMobile={true}
                />
              </Stack>
            </Stack>
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              {isChangingTicket ? (
                <Grid container alignItems="center">
                  <Grid item xs={12} md={6}>
                    {isOperator
                      ? isPrd
                        ? i18nCommon.prdTicketLabel
                        : i18nCommon.operator
                      : i18nCommon.generalPublic}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <SdmSelectV5
                      labelKey={'label'}
                      value={currentTicket.id}
                      onSelect={(e) => onChangeTicketType(e.target.value)}
                      options={ticketOptions}
                    />
                  </Grid>
                </Grid>
              ) : (
                <div>
                  <Typography variant="body1">
                    {!isOperator || isDiscountTicket(currentTicket)
                      ? getProductName(currentTicket, locale)
                      : isPrd
                      ? i18nCommon.prdTicketLabel
                      : i18nCommon.operator}
                  </Typography>
                  {isDiscountTicket(currentTicket) ? (
                    <Typography variant="body2" color={theme.palette.grey[800]}>
                      {i18nDiscount.Common.code}{' '}
                      <strong>
                        {
                          submittedDiscountCodesWithEmptySpaces[
                            stepperCurrentTicketIdx
                          ]
                        }
                      </strong>
                    </Typography>
                  ) : (
                    <></>
                  )}
                </div>
              )}
            </Stack>
          </>
        ) : null}
      </Stack>
    </Box>
  );
};
export default ContainerHeader;
